<template>
  <div v-if="closedModalActive">
    <div class="modal is-active">
      <div class="modal-background" @click="closeModal()"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Shop Closed</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal()"
          ></button>
        </header>
        <section class="modal-card-body">
          <span class="content" style="color: black" v-html="closed_message">
          </span>
          <!-- Content ... -->
        </section>
        <footer class="modal-card-foot">
          <button class="button is-rounded is-primary" @click="closeModal()">
            Close message
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      closedmessage:
        "Unfortunally the store is closed, please come back later.",
    };
  },
  computed: {
    settings() {
      return this.$store.getters["shop/settings"];
    },
    closedModalActive() {
      return this.$store.getters["shop/closedModalActive"];
    },
    closed_message() {
      if (this.settings) {
        const closedmessage = this.settings.variables.find(
          (a) => a.key === "website_closed_message"
        );
        if (closedmessage) {
          return closedmessage.value;
        } else {
          return this.closedmessage;
        }
      } else {
        return this.closedmessage;
      }
    },
  },
  methods: {
    closeModal() {
      return this.$store.dispatch("shop/setClosedModal", false);
    },
  },
  mounted() {},
};
</script>
